import script from "./BackLink.vue?vue&type=script&lang=ts&setup=true"
export * from "./BackLink.vue?vue&type=script&lang=ts&setup=true"

import "./BackLink.vue?vue&type=style&index=0&id=766e2c90&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-766e2c90"]])

export default __exports__